module.exports = __webpack_public_path__ + "img/logo_optimo_login.5b7c10ef.png";